import { render, staticRenderFns } from "./HomeProcurement.vue?vue&type=template&id=395de2fc&scoped=true&"
import script from "./HomeProcurement.vue?vue&type=script&lang=js&"
export * from "./HomeProcurement.vue?vue&type=script&lang=js&"
import style0 from "./HomeProcurement.vue?vue&type=style&index=0&id=395de2fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395de2fc",
  null
  
)

export default component.exports